/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderManualModeFinishingValuesEntry } from '../../models/production-order-manual-mode-finishing-values-entry';

export interface SaveManualModeFinishingValues$Params {
  productionOrderId: number;
      body: ProductionOrderManualModeFinishingValuesEntry
}

export function saveManualModeFinishingValues(http: HttpClient, rootUrl: string, params: SaveManualModeFinishingValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, saveManualModeFinishingValues.PATH, 'post');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

saveManualModeFinishingValues.PATH = '/api/v1/ProductionOrder/{productionOrderId}/SaveManualModeFinishingValues';
